export class LoginResponse {
    token: string; // in caso di errore viene restituito 'ldapLoginFailure'
    idBusinessAccount: string;
    oauthToken: string;
}
